let supressionFlag = false;

export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'green',
          text: this.$store.getters['auth/adminFullname'] + ', добро пожаловать в административную панель!'
        };
      this.$router.push({ path: localStorage.lastVisitedPage ? localStorage.lastVisitedPage : 'staffs/accounts' });
    }
  },
    {
    name: 'APP_LOGIN_USER_STATUS_LOCKED_TIMER',
    callback: function (e) {
        this.snackbar = {
          show: true,
          color: 'black',
          text: `Ваша учетная запись заблокирована${this.$store.getters['userStatus/dateTimeTo'] != null ? ' до ' + this.$store.getters['userStatus/dateTimeTo'] : '.'}`
        };
    }
  },
  {
    name: 'APP_LOGIN_USER_STATUS_LOCKED',
    callback: function (e) {
        this.snackbar = {
          show: true,
          color: 'black',
          text: this.$store.getters['userStatus/notificationText'],
          position: 'center',
          icon: "flag",
          class: 'banhammered',
          timeout: 99999
        };
    }
  },
  {
    name: 'APP_LOGIN_USER_PRELOADED_FOUND',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'green',
          text: 'Пользователь найден',
          position: 'center'
        };
    }
  },
  {
    name: 'APP_LOGIN_USER_PRELOADED_FAILURE',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Пользователь с таким email/номером телефона не найден',
          position: 'center'
        };
    }
  },
  {
    name: 'APP_AUTH_CHECK_FAILED',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Обнаружено две параллельные сессии, перевод на вход'
        };
    }
  },
  {
    name: 'APP_LOGIN_OTP_NO_RETRIES_LEFT',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Вы исчерпали количество попыток, попробуйте позже',
          position: 'center'
        };
    }
  },
  {
    name: 'APP_LOGIN_OTP_SUCCESS',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'green',
          text: 'Авторизация прошла успешно',
          position: 'center'
        };
    }
  },
  {
    name: 'APP_LOGIN_OTP_FAILURE',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Код неверен',
          position: 'center'
        };
    }
  },
  {
    name: 'APP_LOGIN_SUCCESS_REMEMBER_AND_REDIRECT',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'lightgreen',
          text: this.$store.getters['auth/adminFullname'] + ', добро пожаловать, мы вас запомнили!'
        };
      this.$router.push({ path: localStorage.lastVisitedPage ? localStorage.lastVisitedPage : 'staffs/accounts' });
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      //this.$store.dispatch('logout').then(res => {
      this.$store._actions['auth/logout'][0]().then(res => {
        if (!supressionFlag)
          this.snackbar = {
            show: true,
            color: 'green',
            text: 'Вы успешно вышли из административной панели'
          };
        this.$router.replace({ path: '/login' });
      });
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
      if (!supressionFlag);
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Произошла ошибка авторизации!',
          position: 'center'
        };
      this.$router.push('/login');
    }
  },
    {
    name: 'APP_AUTH_FAILED_LOCKED_OUT',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Вам ограничен доступ',
          position: 'center'
        };
      this.$router.push('/login');
    }
  },
  {
    name: 'APP_SERVER_ERROR',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Произошла ошибка сервера.'
        };
    }
  },
  {
    name: 'EMPTY_FIELDS_ERROR',
    callback: function (e) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Заполните обязательные поля!'
        };
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      if (!supressionFlag)
        this.$message.error(msg);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'gray',
          icon: "warning",
          text: 'Доступ запрещен! Авторизируйтесь.',
          position: 'center'
        };

      this.$router.replace('/login');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      if (!supressionFlag)
        this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      if (!supressionFlag)
        this.$message.success(msg);
    }
  },

  {
    name: 'APP_DATA_RECIEVE_SUCCESS',
    // @error api response data
    callback: function (msg) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'green',
          text: msg
        };
    }
  },

  {
    name: 'APP_DATA_RECIEVE_ERROR',
    // @error api response data
    callback: function (msg) {
      if (!supressionFlag)
        this.snackbar = {
          show: true,
          color: 'red',
          text: msg
        };
    }
  },


];



// WEBPACK FOOTER //
// ./src/event.js